import { render, staticRenderFns } from "./ProceedToPaymentModal.vue?vue&type=template&id=95bf255a&scoped=true"
import script from "./ProceedToPaymentModal.vue?vue&type=script&lang=js"
export * from "./ProceedToPaymentModal.vue?vue&type=script&lang=js"
import style0 from "./ProceedToPaymentModal.vue?vue&type=style&index=0&id=95bf255a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bf255a",
  null
  
)

export default component.exports